import React from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';

import colors from '@constants/colors';
import { taskLinkTypesNames } from '@components/ModalComponents/TaskForm/LinkTasksForm/constants';

import { drownPathAndTriangle } from './utils';

type ArrowProps = {
	taskFrom: BarTask;
	taskTo: BarTask;
	rowHeight: number;
	taskHeight: number;
	arrowIndent: number;
	isActive?: boolean;
	linkType?: string;
};

const ARROW_STROKE_WIDTH = '1.5';
const INACTIVE_ARROW_STROKE_WIDTH = '0.5';

const Arrow: React.FC<ArrowProps> = ({
	taskFrom,
	taskTo,
	rowHeight,
	taskHeight,
	arrowIndent,
	isActive = true,
	linkType = taskLinkTypesNames.finishToStart,
}) => {
	const [path, trianglePoints] = drownPathAndTriangle({
		taskFrom,
		taskTo,
		rowHeight,
		taskHeight,
		arrowIndent,
		isActive,
		linkType,
	});

	const arrowColor = isActive ? colors.indigo70 : colors.gray50;
	const strokeWidth = isActive ? ARROW_STROKE_WIDTH : INACTIVE_ARROW_STROKE_WIDTH;

	return (
		<g className='arrow'>
			<path
				d={path}
				fill='none'
				stroke={arrowColor}
				strokeWidth={strokeWidth}
			/>
			<polygon
				fill={arrowColor}
				points={trianglePoints}
				stroke={arrowColor}
			/>
		</g>
	);
};

export default Arrow;
